import auth from './auth'
import facilities from './facilities'
import geoLookup from './geo-lookup'
import investments from './investments'
import projects from './projects'
import storage from './storage'
import userProfile from './user-profile'
import users from './users'

export default {
  auth,
  facilities,
  'geo-lookup': geoLookup,
  investments,
  projects,
  storage,
  'user-profile': userProfile,
  users
}
